import React from "react";
import { Route, Routes } from "react-router-dom";
import LoyaltyUsers from "./users";
import LoyaltyRewards from "./rewards";

const Loyalty = () => {
  return (
    <Routes>
      <Route path="users" element={<LoyaltyUsers />} />
      <Route path="rewards" element={<LoyaltyRewards />} />
    </Routes>
  );
};

export default Loyalty;
